import { useQuery, UseQueryOptions } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { GET_URL } from '@utils/api/endpoints.ts';
import { BaseError, BaseResponse } from '@utils/types/shared/base.ts';
import { QueryKeys } from '@utils/api/query-keys.ts';
import { AxiosError } from 'axios';
import { QrCodeResponse } from '@utils/types/users/2fa.ts';

export async function getQrCode(): Promise<BaseResponse<QrCodeResponse>> {
  const { data } = await Axios.get(GET_URL().qrCode2fa);
  return data;
}

export function useGet2faQrCode(
  options?: UseQueryOptions<BaseResponse<QrCodeResponse>, AxiosError<BaseError>>
) {
  return useQuery<BaseResponse<QrCodeResponse>, AxiosError<BaseError>>(
    QueryKeys.qrCode2fa(),
    getQrCode,
    options
  );
}
